import Api from "../utils/api";

const ProductService = {
  admin: {
    getPackages: async (params = {}) =>
      Api.createResponse("app/admin/products/packages", params),
    upload: async (params = {}) =>
      Api.createResponse("app/admin/products/upload", params),
    save: async (params = {}) =>
      Api.createResponse("app/admin/products/save", params),
  },
};

export default ProductService;
